import React from 'react';
import ErrorMessage from './ErrorMessage';
import './FormField.css';

/**
 * 공통 폼 필드 컴포넌트
 * @param {string} label - 필드 라벨
 * @param {string} type - 입력 타입
 * @param {string} value - 입력값
 * @param {Function} onChange - 변경 핸들러
 * @param {string} placeholder - 플레이스홀더
 * @param {boolean} required - 필수 여부
 * @param {string} error - 에러 메시지
 * @param {Object} options - select 옵션들
 * @param {boolean} disabled - 비활성화 여부
 * @param {string} className - 추가 CSS 클래스
 */
const FormField = ({
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  error,
  options = [],
  disabled = false,
  className = '',
  ...props
}) => {
  const fieldId = `field-${Math.random().toString(36).substr(2, 9)}`;

  const renderInput = () => {
    switch (type) {
      case 'select':
        return (
          <select
            id={fieldId}
            value={value || ''}
            onChange={onChange}
            disabled={disabled}
            className={`form-input select-input ${error ? 'error' : ''} ${className}`}
            {...props}
          >
            {placeholder && <option value="">{placeholder}</option>}
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );
      
      case 'textarea':
        return (
          <textarea
            id={fieldId}
            value={value || ''}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            className={`form-input textarea-input ${error ? 'error' : ''} ${className}`}
            {...props}
          />
        );
      
      case 'checkbox':
        return (
          <label className="checkbox-label">
            <input
              id={fieldId}
              type="checkbox"
              checked={value || false}
              onChange={onChange}
              disabled={disabled}
              className={`form-input checkbox-input ${error ? 'error' : ''} ${className}`}
              {...props}
            />
            <span className="checkbox-text">{label}</span>
          </label>
        );
      
      default:
        return (
          <input
            id={fieldId}
            type={type}
            value={value || ''}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            className={`form-input ${error ? 'error' : ''} ${className}`}
            {...props}
          />
        );
    }
  };

  if (type === 'checkbox') {
    return (
      <div className="form-field checkbox-field">
        {renderInput()}
        {error && <ErrorMessage message={error} type="error" />}
      </div>
    );
  }

  return (
    <div className="form-field">
      <label htmlFor={fieldId} className="form-label">
        {label}
        {required && <span className="required">*</span>}
      </label>
      {renderInput()}
      {error && <ErrorMessage message={error} type="error" />}
    </div>
  );
};

export default FormField;
